import { render } from "./NavSearchModal.3.vue?vue&type=template&id=4040965a&scoped=true&ts=true"
import script from "./NavSearchModal.3.vue?vue&type=script&lang=ts"
export * from "./NavSearchModal.3.vue?vue&type=script&lang=ts"

import "./NavSearchModal.3.vue?vue&type=style&index=0&id=4040965a&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4040965a"]])

export default __exports__